/* Refillia: sconto di benvenuto da grattare. La cartolina mostra solo il codice, uguale per tutti */
(function () {
  var velo = document.querySelector('[data-rfbv]');
  if (!velo) return;
  var box = velo.querySelector('.rfbv'), carta = velo.querySelector('[data-rfbv-carta]'), tab = document.querySelector('[data-rfbv-tab]');
  var codice = velo.dataset.codice, giorni = parseInt(velo.dataset.giorni, 10) || 7, ritardo = (parseInt(velo.dataset.ritardo, 10) || 16) * 1000;
  var K_VISTO = 'rf-benvenuto-visto', K_GRATTATO = 'rf-benvenuto-grattato', K_TAB = 'rf-benvenuto-tab';
  function leggi(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function scrivi(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  var prima = null, pronta = false;

  function copertura() {
    var cv = carta.querySelector('canvas'), r = window.devicePixelRatio || 1, w = carta.clientWidth, h = carta.clientHeight;
    cv.width = w * r; cv.height = h * r;
    var c = cv.getContext('2d'); c.setTransform(r, 0, 0, r, 0, 0); c.globalCompositeOperation = 'source-over';
    var g = c.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#c4c8c1'); g.addColorStop(0.42, '#f1f3ef'); g.addColorStop(0.55, '#dde0da'); g.addColorStop(1, '#b3b8b0');
    c.fillStyle = g; c.fillRect(0, 0, w, h);
    c.globalAlpha = 0.16; c.fillStyle = '#023a20';
    for (var y = 8; y < h; y += 14) for (var x = (y / 14 % 2) * 7; x < w; x += 14) { c.beginPath(); c.arc(x, y, 1.5, 0, 7); c.fill(); }
    c.globalAlpha = 1; c.fillStyle = '#023a20'; c.textAlign = 'center';
    c.font = '400 26px "Cal Sans", sans-serif'; c.fillText('Gratta qui', w / 2, h / 2);
    c.font = '700 12px "Google Sans Flex", sans-serif'; c.fillStyle = '#3d4640'; c.fillText('per scoprire il tuo codice', w / 2, h / 2 + 22);
    var giu = false, passi = 0;
    function punto(e) {
      var b = cv.getBoundingClientRect();
      c.globalCompositeOperation = 'destination-out';
      c.beginPath(); c.arc(e.clientX - b.left, e.clientY - b.top, Math.max(18, b.width * 0.07), 0, 7); c.fill();
      if (++passi % 8 === 0) misura();
    }
    function misura() {
      var d = c.getImageData(0, 0, cv.width, cv.height).data, vuoti = 0, n = 0;
      for (var i = 3; i < d.length; i += 80) { n++; if (d[i] < 20) vuoti++; }
      if (vuoti / n > 0.5) apriCodice();
    }
    cv.onpointerdown = function (e) { giu = true; try { cv.setPointerCapture(e.pointerId); } catch (x) {} punto(e); };
    cv.onpointermove = function (e) { if (giu) punto(e); };
    cv.onpointerup = function () { giu = false; misura(); };
  }
  function apriCodice() {
    if (box.classList.contains('aperta')) return;
    box.classList.add('aperta');
    scrivi(K_GRATTATO, '1');
  }
  function mostra() {
    prima = document.activeElement;
    velo.hidden = false;
    document.documentElement.classList.add('rfbv-bloccato');
    scrivi(K_VISTO, String(Date.now()));
    if (leggi(K_GRATTATO)) box.classList.add('aperta');
    else if (!pronta) { pronta = true; requestAnimationFrame(copertura); }
    velo.querySelector('[data-rfbv-chiudi]').focus({ preventScroll: true });
  }
  function chiudi() {
    velo.hidden = true;
    box.classList.remove('reg');
    document.documentElement.classList.remove('rfbv-bloccato');
    if (prima && prima.focus) prima.focus({ preventScroll: true });
  }

  velo.addEventListener('click', function (e) {
    if (e.target === velo || e.target.closest('[data-rfbv-chiudi]')) chiudi();
    if (e.target.closest('[data-rfbv-mostra]')) apriCodice();
    if (e.target.closest('[data-rfbv-reg]')) box.classList.add('reg');
    if (e.target.closest('[data-rfbv-reg-chiudi]')) box.classList.remove('reg');
    var cp = e.target.closest('[data-rfbv-copia]');
    if (cp) {
      (navigator.clipboard ? navigator.clipboard.writeText(codice) : Promise.reject()).then(function () { cp.textContent = 'Codice copiato'; }, function () { cp.textContent = 'Il codice è ' + codice; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !velo.hidden) chiudi(); });

  /* "Applica lo sconto": niente pagina carrello, si apre il nostro carrello laterale con il codice già inserito */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  velo.querySelector('.rfbv-applica').addEventListener('click', function (e) {
    if (!window.RfCarrello) return;
    e.preventDefault();
    chiudi();
    fetch(root + 'discount/' + encodeURIComponent(codice), { credentials: 'same-origin' }).catch(function () {});
    window.RfCarrello.apri(true);
    var giri = 0, pronto = false;
    Promise.resolve(window.RfCarrello.aggiorna && window.RfCarrello.aggiorna()).then(function () { pronto = true; }, function () { pronto = true; });
    (function prova() {
      var f = pronto && [].slice.call(document.querySelectorAll('.rfk [data-rfk-cod]')).filter(function (x) { return x.offsetParent !== null; })[0];
      if (f) {
        f.querySelector('input').value = codice;
        if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        return;
      }
      if (++giri < 30) { setTimeout(prova, 150); return; }
      // carrello vuoto: il codice resta salvato e si applica al primo prodotto aggiunto
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codice }) })
        .then(function () { if (window.RfCarrello.aggiorna) window.RfCarrello.aggiorna(); }).catch(function () {});
    })();
  });

  var form = velo.querySelector('[data-rfbv-form]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var dati = new FormData(form);
    fetch(form.action, { method: 'POST', body: dati, credentials: 'same-origin' })
      .then(function (r) { if (r.url && /challenge/.test(r.url)) throw new Error('verifica'); box.classList.add('email'); })
      .catch(function () { form.submit(); });
  });

  if (tab) {
    try { if (!sessionStorage.getItem(K_TAB)) tab.hidden = false; } catch (e) { tab.hidden = false; }
    tab.querySelector('[data-rfbv-apri]').addEventListener('click', mostra);
    tab.querySelector('[data-rfbv-tab-x]').addEventListener('click', function () { tab.hidden = true; try { sessionStorage.setItem(K_TAB, '1'); } catch (e) {} });
  }
  // compare da solo solo a chi non l'ha grattata, al massimo una volta ogni tot giorni
  var visto = parseInt(leggi(K_VISTO) || '0', 10);
  if (!leggi(K_GRATTATO) && Date.now() - visto > giorni * 86400000) {
    setTimeout(function () { if (velo.hidden && !document.querySelector('.rfsp-velo:not([hidden])')) mostra(); }, ritardo);
  }
  window.RF_BENVENUTO = { apri: mostra };
})();
